/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  
document.querySelectorAll('.klaviyo-bis-trigger').forEach(function(button) {
  button.addEventListener('click', function() {
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openBackInStockModal', {
      variantId: button.getAttribute('data-variant-id'),
      productId: button.getAttribute('data-product-id'),
      productName: button.getAttribute('data-product-name'),
      productUrl: button.getAttribute('data-product-url')
    }]);
  });
});

if (window.location.search.includes('notifyme=true')) {
  setTimeout(function() {
    var trigger = document.querySelector('a.klaviyo-bis-trigger');
    if (trigger) trigger.click();
  }, 200);
}



  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
